/**
 * Creates a dom element representing a location cluster.
 * @param backgroundColor color to assign to the cluster
 */
const createLocationCluster: (backgroundColor: string) => HTMLElement = (backgroundColor: string) => {
  const container = document.createElement('div');
  const style = {
    backgroundColor: `${backgroundColor}`,
    border: 'solid',
    borderWidth: '0.15em',
    borderColor: '#FFFFFF',
    borderRadius: '1em',
    clipPath: 'circle(50%)',
    width: '1em',
    height: '1em',
    position: 'relative',
  }
  Object.assign(container.style, style);
  return container;
}

export default createLocationCluster;
